module.exports = __webpack_public_path__ + "static/img/before_login_bottom_bg.7245b7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/before_login_bottom_bg.png
// module id = 9Nm+
// module chunks = 1